/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ServiceAdminSearchUsersQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ServiceAdminSearchUsersQuery = { __typename: 'Query', serviceAdminSearchUsers: { __typename: 'ServiceAdminUserSearchPayload', totalCount: number, results: Array<{ __typename: 'ServiceAdminUserSearchResult', id: string, email: string, givenName?: string | null, familyName?: string | null, organizationId: string, organizationName: string, roles: Array<Types.Role>, lastLogin?: any | null, accessState: Types.ServiceAdminGlobalSearchAccessState }> } };

export type ServiceAdminResendInviteMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID'];
}>;


export type ServiceAdminResendInviteMutation = { __typename: 'Mutation', serviceAdminUserResendInvite: boolean };

export type ServiceAdminUserDeleteMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID'];
}>;


export type ServiceAdminUserDeleteMutation = { __typename: 'Mutation', serviceAdminUserDelete: { __typename: 'UserDeletePayload', userId: string } };


export const ServiceAdminSearchUsersDocument = gql`
    query ServiceAdminSearchUsers($searchTerm: String!, $pageSize: Int, $pageNumber: Int) {
  serviceAdminSearchUsers(
    searchTerm: $searchTerm
    pageSize: $pageSize
    pageNumber: $pageNumber
  ) {
    totalCount
    results {
      id
      email
      givenName
      familyName
      organizationId
      organizationName
      roles
      lastLogin
      accessState
    }
  }
}
    `;

/**
 * __useServiceAdminSearchUsersQuery__
 *
 * To run a query within a React component, call `useServiceAdminSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAdminSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAdminSearchUsersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useServiceAdminSearchUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServiceAdminSearchUsersQuery, ServiceAdminSearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServiceAdminSearchUsersQuery, ServiceAdminSearchUsersQueryVariables>(ServiceAdminSearchUsersDocument, options);
      }
export function useServiceAdminSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceAdminSearchUsersQuery, ServiceAdminSearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServiceAdminSearchUsersQuery, ServiceAdminSearchUsersQueryVariables>(ServiceAdminSearchUsersDocument, options);
        }
export type ServiceAdminSearchUsersQueryHookResult = ReturnType<typeof useServiceAdminSearchUsersQuery>;
export type ServiceAdminSearchUsersLazyQueryHookResult = ReturnType<typeof useServiceAdminSearchUsersLazyQuery>;
export type ServiceAdminSearchUsersQueryResult = ApolloReactCommon.QueryResult<ServiceAdminSearchUsersQuery, ServiceAdminSearchUsersQueryVariables>;
export const ServiceAdminResendInviteDocument = gql`
    mutation ServiceAdminResendInvite($userId: ID!) {
  serviceAdminUserResendInvite(userId: $userId)
}
    `;
export type ServiceAdminResendInviteMutationFn = ApolloReactCommon.MutationFunction<ServiceAdminResendInviteMutation, ServiceAdminResendInviteMutationVariables>;

/**
 * __useServiceAdminResendInviteMutation__
 *
 * To run a mutation, you first call `useServiceAdminResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceAdminResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceAdminResendInviteMutation, { data, loading, error }] = useServiceAdminResendInviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useServiceAdminResendInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ServiceAdminResendInviteMutation, ServiceAdminResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ServiceAdminResendInviteMutation, ServiceAdminResendInviteMutationVariables>(ServiceAdminResendInviteDocument, options);
      }
export type ServiceAdminResendInviteMutationHookResult = ReturnType<typeof useServiceAdminResendInviteMutation>;
export type ServiceAdminResendInviteMutationResult = ApolloReactCommon.MutationResult<ServiceAdminResendInviteMutation>;
export type ServiceAdminResendInviteMutationOptions = ApolloReactCommon.BaseMutationOptions<ServiceAdminResendInviteMutation, ServiceAdminResendInviteMutationVariables>;
export const ServiceAdminUserDeleteDocument = gql`
    mutation ServiceAdminUserDelete($userId: ID!) {
  serviceAdminUserDelete(userId: $userId) {
    userId
  }
}
    `;
export type ServiceAdminUserDeleteMutationFn = ApolloReactCommon.MutationFunction<ServiceAdminUserDeleteMutation, ServiceAdminUserDeleteMutationVariables>;

/**
 * __useServiceAdminUserDeleteMutation__
 *
 * To run a mutation, you first call `useServiceAdminUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceAdminUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceAdminUserDeleteMutation, { data, loading, error }] = useServiceAdminUserDeleteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useServiceAdminUserDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ServiceAdminUserDeleteMutation, ServiceAdminUserDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ServiceAdminUserDeleteMutation, ServiceAdminUserDeleteMutationVariables>(ServiceAdminUserDeleteDocument, options);
      }
export type ServiceAdminUserDeleteMutationHookResult = ReturnType<typeof useServiceAdminUserDeleteMutation>;
export type ServiceAdminUserDeleteMutationResult = ApolloReactCommon.MutationResult<ServiceAdminUserDeleteMutation>;
export type ServiceAdminUserDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<ServiceAdminUserDeleteMutation, ServiceAdminUserDeleteMutationVariables>;